import PropTypes from "prop-types";
import React from 'react';
import {Translate} from "react-localize-redux";
import {FormFeedback, Label, Input, FormGroup, Button} from "reactstrap";
import {isEmptyString} from "../../../../utils/string-utils";
import {Form, Formik} from "formik";

const propTypes = {
  config: PropTypes.shape({
    enable: PropTypes.bool.isRequired,
    pattern: PropTypes.string
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const MediaSettingsFormCleaner = (props) => {
  const { config } = props;

  const handleSubmit = (values, { resetForm }) => {
    if(!values.enable && isEmptyString(values.pattern)){
      values.pattern = props.config.pattern;
    }
    props.onSubmit(values);
    resetForm(values);
  };

  const handleValidation = (values) => {
    const errors = {};

    if(values.enable){
      if(isEmptyString(values.pattern)) {
        errors.pattern = 'genericLabel.REQUIRED_FIELD.text';
      }
    }
    return errors;
  };


  return (
    <Formik initialValues={{
              enable: config.enable,
              pattern: config.pattern
            }}
            validateOnBlur={false}
            validateOnChange={true}
            validate={ handleValidation }
            onSubmit={ handleSubmit }>
      {({
          values,
          errors,
          dirty,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => (
        <Form onSubmit={handleSubmit}>
          <FormGroup check>
            <Label check>
              <Input id="media_renamer_enableRenamer"
                     type="checkbox"
                     name="enable"
                     onChange={handleChange}
                     checked={values.enable}/>{' '}
              <Translate id="genericLabel.ENABLE_FILE_RENAME.text"/>
            </Label>
          </FormGroup>
          <FormGroup>
            <Label for="pattern">
              <Translate id="genericLabel.RENAME_RULES.text"/>
            </Label>
            <Input type="text"
                   name="pattern"
                   id="media_renamer_pattern"
                   invalid={ errors.pattern !== undefined }
                   disabled={true}
                   value={values.pattern}
                   onBlur={handleBlur}
                   onChange={handleChange}/>
            <FormFeedback>
              <Translate id={errors.pattern}/>
            </FormFeedback>
          </FormGroup>
          <FormGroup className="buttons">
            <Button id="media_renamer_saveButton"
                    color="primary"
                    disabled={isSubmitting || !dirty}
                    type="submit">
              <Translate id="genericLabel.SAVE.text"/>
            </Button>
          </FormGroup>
        </Form>
      )}
    </Formik>
  );
};

MediaSettingsFormCleaner.propTypes = propTypes;

export default MediaSettingsFormCleaner;